// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createPromptModuleRequestToJson, createPromptModuleResponseFromJson, createPromptModuleVersionRequestToJson, deletePromptModuleRequestToJson, deployPromptModuleRequestToJson, getDeployedPromptModuleVersionRequestToJson, getDeployedPromptModuleVersionResponseFromJson, getHydratedDeployedPromptModuleVersionRequestToJson, getHydratedDeployedPromptModuleVersionResponseFromJson, getHydratedPromptModuleVersionRequestToJson, getHydratedPromptModuleVersionResponseFromJson, getMultiHydratedDeployedPromptModuleVersionRequestToJson, getMultiHydratedDeployedPromptModuleVersionResponseFromJson, getPromptModuleRequestToJson, getPromptModuleResponseFromJson, getPromptModuleVersionRequestToJson, getPromptModuleVersionResponseFromJson, listPromptModuleRequestToJson, listPromptModuleResponseFromJson, listPromptModuleVersionsRequestToJson, listPromptModuleVersionsResponseFromJson, serializePromptModuleRequestToJson, serializePromptModuleResponseFromJson, updatePromptModuleRequestToJson, validatePromptModuleRequestToJson, validatePromptModuleResponseFromJson, validatePromptModuleVersionsRequestToJson, validatePromptModuleVersionsResponseFromJson, validatePromptModulesRequestToJson, validatePromptModulesResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function create(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/Create', createPromptModuleRequestToJson(request));
    return createPromptModuleResponseFromJson(raw);
}
export function create$(request, options) {
    return defer(() => createWithTransport$(getGlobalTransport(), request, options));
}
export function createWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/Create', createPromptModuleRequestToJson(request), options)
        .pipe(map(resp => createPromptModuleResponseFromJson(resp)));
}
export async function createVersion(request) {
    await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/CreateVersion', createPromptModuleVersionRequestToJson(request));
}
export function createVersion$(request, options) {
    return defer(() => createVersionWithTransport$(getGlobalTransport(), request, options));
}
export function createVersionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/CreateVersion', createPromptModuleVersionRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function get(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/Get', getPromptModuleRequestToJson(request));
    return getPromptModuleResponseFromJson(raw);
}
export function get$(request, options) {
    return defer(() => getWithTransport$(getGlobalTransport(), request, options));
}
export function getWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/Get', getPromptModuleRequestToJson(request), options)
        .pipe(map(resp => getPromptModuleResponseFromJson(resp)));
}
export async function getVersion(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/GetVersion', getPromptModuleVersionRequestToJson(request));
    return getPromptModuleVersionResponseFromJson(raw);
}
export function getVersion$(request, options) {
    return defer(() => getVersionWithTransport$(getGlobalTransport(), request, options));
}
export function getVersionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/GetVersion', getPromptModuleVersionRequestToJson(request), options)
        .pipe(map(resp => getPromptModuleVersionResponseFromJson(resp)));
}
export async function getDeployedVersion(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/GetDeployedVersion', getDeployedPromptModuleVersionRequestToJson(request));
    return getDeployedPromptModuleVersionResponseFromJson(raw);
}
export function getDeployedVersion$(request, options) {
    return defer(() => getDeployedVersionWithTransport$(getGlobalTransport(), request, options));
}
export function getDeployedVersionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/GetDeployedVersion', getDeployedPromptModuleVersionRequestToJson(request), options)
        .pipe(map(resp => getDeployedPromptModuleVersionResponseFromJson(resp)));
}
export async function getHydratedDeployedVersion(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/GetHydratedDeployedVersion', getHydratedDeployedPromptModuleVersionRequestToJson(request));
    return getHydratedDeployedPromptModuleVersionResponseFromJson(raw);
}
export function getHydratedDeployedVersion$(request, options) {
    return defer(() => getHydratedDeployedVersionWithTransport$(getGlobalTransport(), request, options));
}
export function getHydratedDeployedVersionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/GetHydratedDeployedVersion', getHydratedDeployedPromptModuleVersionRequestToJson(request), options)
        .pipe(map(resp => getHydratedDeployedPromptModuleVersionResponseFromJson(resp)));
}
export async function getHydratedVersion(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/GetHydratedVersion', getHydratedPromptModuleVersionRequestToJson(request));
    return getHydratedPromptModuleVersionResponseFromJson(raw);
}
export function getHydratedVersion$(request, options) {
    return defer(() => getHydratedVersionWithTransport$(getGlobalTransport(), request, options));
}
export function getHydratedVersionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/GetHydratedVersion', getHydratedPromptModuleVersionRequestToJson(request), options)
        .pipe(map(resp => getHydratedPromptModuleVersionResponseFromJson(resp)));
}
export async function getMultiHydratedDeployedVersion(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/GetMultiHydratedDeployedVersion', getMultiHydratedDeployedPromptModuleVersionRequestToJson(request));
    return getMultiHydratedDeployedPromptModuleVersionResponseFromJson(raw);
}
export function getMultiHydratedDeployedVersion$(request, options) {
    return defer(() => getMultiHydratedDeployedVersionWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiHydratedDeployedVersionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/GetMultiHydratedDeployedVersion', getMultiHydratedDeployedPromptModuleVersionRequestToJson(request), options)
        .pipe(map(resp => getMultiHydratedDeployedPromptModuleVersionResponseFromJson(resp)));
}
export async function update(request) {
    await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/Update', updatePromptModuleRequestToJson(request));
}
export function update$(request, options) {
    return defer(() => updateWithTransport$(getGlobalTransport(), request, options));
}
export function updateWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/Update', updatePromptModuleRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function deploy(request) {
    await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/Deploy', deployPromptModuleRequestToJson(request));
}
export function deploy$(request, options) {
    return defer(() => deployWithTransport$(getGlobalTransport(), request, options));
}
export function deployWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/Deploy', deployPromptModuleRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function list(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/List', listPromptModuleRequestToJson(request));
    return listPromptModuleResponseFromJson(raw);
}
export function list$(request, options) {
    return defer(() => listWithTransport$(getGlobalTransport(), request, options));
}
export function listWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/List', listPromptModuleRequestToJson(request), options)
        .pipe(map(resp => listPromptModuleResponseFromJson(resp)));
}
export async function listVersions(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/ListVersions', listPromptModuleVersionsRequestToJson(request));
    return listPromptModuleVersionsResponseFromJson(raw);
}
export function listVersions$(request, options) {
    return defer(() => listVersionsWithTransport$(getGlobalTransport(), request, options));
}
export function listVersionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/ListVersions', listPromptModuleVersionsRequestToJson(request), options)
        .pipe(map(resp => listPromptModuleVersionsResponseFromJson(resp)));
}
export async function delete_(request) {
    await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/Delete', deletePromptModuleRequestToJson(request));
}
export function delete_$(request, options) {
    return defer(() => delete_WithTransport$(getGlobalTransport(), request, options));
}
export function delete_WithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/Delete', deletePromptModuleRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function validate(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/Validate', validatePromptModuleRequestToJson(request));
    return validatePromptModuleResponseFromJson(raw);
}
export function validate$(request, options) {
    return defer(() => validateWithTransport$(getGlobalTransport(), request, options));
}
export function validateWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/Validate', validatePromptModuleRequestToJson(request), options)
        .pipe(map(resp => validatePromptModuleResponseFromJson(resp)));
}
export async function validatePromptModules(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/ValidatePromptModules', validatePromptModulesRequestToJson(request));
    return validatePromptModulesResponseFromJson(raw);
}
export function validatePromptModules$(request, options) {
    return defer(() => validatePromptModulesWithTransport$(getGlobalTransport(), request, options));
}
export function validatePromptModulesWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/ValidatePromptModules', validatePromptModulesRequestToJson(request), options)
        .pipe(map(resp => validatePromptModulesResponseFromJson(resp)));
}
export async function validatePromptModuleVersions(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/ValidatePromptModuleVersions', validatePromptModuleVersionsRequestToJson(request));
    return validatePromptModuleVersionsResponseFromJson(raw);
}
export function validatePromptModuleVersions$(request, options) {
    return defer(() => validatePromptModuleVersionsWithTransport$(getGlobalTransport(), request, options));
}
export function validatePromptModuleVersionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/ValidatePromptModuleVersions', validatePromptModuleVersionsRequestToJson(request), options)
        .pipe(map(resp => validatePromptModuleVersionsResponseFromJson(resp)));
}
export async function serializePromptModule(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.PromptModuleService/SerializePromptModule', serializePromptModuleRequestToJson(request));
    return serializePromptModuleResponseFromJson(raw);
}
export function serializePromptModule$(request, options) {
    return defer(() => serializePromptModuleWithTransport$(getGlobalTransport(), request, options));
}
export function serializePromptModuleWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.PromptModuleService/SerializePromptModule', serializePromptModuleRequestToJson(request), options)
        .pipe(map(resp => serializePromptModuleResponseFromJson(resp)));
}
